export default {"src":"/_next/static/media/liner.e6e24f99.svg","height":5,"width":289,"blurWidth":0,"blurHeight":0};